<style lang="scss">
/* ===== PC Layout Container ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Modal Width Override ===== */
:deep(.ant-modal) {
    max-width: none !important;
}

.not-developer-praent {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.not-developer-div {
    padding: 1.5rem;
    width: fit-content;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    text-align: center;

    p {
        font-size: 1rem;
        color: #333;
        margin-bottom: 1rem;
    }
}

/* ===== Toolbar ===== */
.table-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
    flex-wrap: wrap;
}

.toolbar-label {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
}

/* ===== Table Card ===== */
.table-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 0;
    }
}

/* ===== Mobile Card List ===== */
.notice-card-list {
    display: none;
    flex-direction: column;
    gap: 12px;
    padding: 16px;

    .notice-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .mobile-card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mobile-card-title {
        font-weight: 600;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 10px;
    }

    .mobile-field {
        display: flex;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 72px;
        flex-shrink: 0;
        font-size: 12px;
        line-height: 30px;
    }

    .mobile-value {
        flex: 1;
        min-width: 0;
    }

    .mobile-card-foot {
        display: flex;
        gap: 8px;
        padding-top: 8px;
        border-top: 1px solid #f5f5f5;
    }
}

/* ===== Pagination ===== */
.table-pagination {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px 16px;
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {
    .ant-layout-content {
        padding: 12px !important;
    }

    /* Toggle */
    .notice-table-pc,
    .table-pagination {
        display: none !important;
    }

    .notice-card-list {
        display: flex !important;
    }

    .table-card :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .table-toolbar {
        padding: 10px 12px;
    }

    .not-developer-div {
        padding: 1rem;
    }
}

/* Very small phones */
@media screen and (max-width: 480px) {
    .ant-layout-content {
        padding: 8px !important;
    }
}
</style>
<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <div v-if="isDeveloper == 0" class="not-developer-praent">
                        <div class="not-developer-div">
                            <p>您还不是开发者，暂时无法查看本页面喔~</p>
                            <div style="text-align: center; width: fit-content; margin: 1rem auto 0.5rem;">
                                <a-button type="primary" @click="goApiUrl">成为开发者</a-button>
                            </div>
                        </div>
                    </div>

                    <a-card v-if="isDeveloper == 1" :bordered="false" class="table-card">
                        <template #title>
                            <div style="font-weight: 600;">公告管理</div>
                        </template>
                        <template #extra>
                            <a-button type="primary" @click="noticeRelease.isShow = true">公告发布</a-button>
                        </template>

                        <div class="table-toolbar">
                            <span class="toolbar-label">请选择插件</span>
                            <a-select v-model:value="selectIncludesId" placeholder="请选择" style="width: 200px;"
                                @change="getNoticeByIncludes">
                                <a-select-option label="全部" :value="-1"></a-select-option>
                                <a-select-option v-for="item in includes_data" :key="item.id" :value="item.id">{{
                                    item.id }}---{{ item.name ||
                                        item.includes_name }}</a-select-option>
                            </a-select>
                        </div>

                        <!-- PC端表格 -->
                        <a-table class="notice-table-pc" :data-source="noticeList" :pagination="false" row-key="id"
                            :scroll="{ x: 1200 }" size="small" bordered :columns="noticeColumns">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'title'">
                                    <a-input style="width: 200px;" type="textarea"
                                        :auto-size="{ minRows: 1, maxRows: 3 }" v-model:value="record.title"></a-input>
                                </template>
                                <template v-else-if="column.key === 'content'">
                                    <a-input v-model:value="record.content" :auto-size="{ minRows: 1, maxRows: 10 }"
                                        type="textarea" style="width: 100%; max-width: 360px;"></a-input>
                                </template>
                                <template v-else-if="column.key === 'action'">
                                    <a-space size="small">
                                        <a-button type="primary" size="small" @click="saveNotice(record)">保存</a-button>
                                        <a-button danger size="small" @click="deleteNotice(record.id)">删除</a-button>
                                    </a-space>
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="notice-card-list" v-if="noticeList && noticeList.length > 0">
                            <a-card v-for="record in noticeList" :key="record.id" class="notice-mobile-card"
                                :bordered="false">
                                <div class="mobile-card-head">
                                    <span class="mobile-card-title">公告 #{{ record.id }} {{ record.title }}</span>
                                    <a-tag color="blue">插件 #{{ record.pluginId }}</a-tag>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">标题</span>
                                        <span class="mobile-value">
                                            <a-input type="textarea" :auto-size="{ minRows: 1, maxRows: 2 }"
                                                v-model:value="record.title"></a-input>
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">内容</span>
                                        <span class="mobile-value">
                                            <a-input type="textarea" :auto-size="{ minRows: 2, maxRows: 6 }"
                                                v-model:value="record.content"></a-input>
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">发布时间</span>
                                        <span class="mobile-value">{{ record.create_date }}</span>
                                    </div>
                                </div>
                                <div class="mobile-card-foot">
                                    <a-button type="primary" size="small" @click="saveNotice(record)">保存</a-button>
                                    <a-button danger size="small" @click="deleteNotice(record.id)">删除</a-button>
                                </div>
                            </a-card>
                        </div>

                        <!-- 空状态 -->
                        <a-empty v-if="(!noticeList || noticeList.length === 0)" description="暂无公告数据"
                            style="padding: 32px;" />

                        <!-- 分页 -->
                        <div class="table-pagination">
                            <a-pagination v-model:current="noticePage.currentPage" :page-size="noticePage.pageSize"
                                :page-size-options="[5, 10, 20]" show-size-changer show-quick-jumper
                                :show-total="(total) => `共 ${total} 条`" :total="noticePage.total"
                                @change="currentChange" />
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>

    <!-- 公告发布 -->
    <a-modal v-model:open="noticeRelease.isShow" title="公告发布" :width="560" :footer="null" centered>
        <a-form layout="vertical">
            <a-form-item label="插件">
                <a-select v-model:value="noticeRelease.data.pluginId" placeholder="请选择">
                    <a-select-option v-for="item in includes_data" :key="item.id" :value="item.id">
                        {{ item.id }}---{{ item.name || item.includes_name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="标题">
                <a-input type="textarea" :rows="1" v-model:value="noticeRelease.data.title" autocomplete="off" />
            </a-form-item>
            <a-form-item label="内容">
                <a-input type="textarea" :auto-size="{ minRows: 2, maxRows: 10 }"
                    v-model:value="noticeRelease.data.content" autocomplete="off" />
            </a-form-item>
        </a-form>
        <div style="text-align: right; margin-top: 16px;">
            <a-button @click="noticeRelease.isShow = false">关闭</a-button>
            <a-button type="primary" @click="addNotice">新增</a-button>
        </div>
    </a-modal>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isLogin, isNull, compareDates, openBox, getIncludesList } from "@/utils/publicMethods"
import { message } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            isDeveloper: 2,
            deveploerConf: {
                apiUrl: ""
            },
            noticeList: [],
            noticeColumns: [
                { title: '公告ID', dataIndex: 'id', key: 'id', width: 80, align: 'center' },
                { title: '标题', dataIndex: 'title', key: 'title', width: 260 },
                { title: '内容', dataIndex: 'content', key: 'content' },
                { title: '发布时间', dataIndex: 'create_date', key: 'create_date', width: 180, align: 'center' },
                { title: '插件ID', dataIndex: 'pluginId', key: 'pluginId', width: 80, align: 'center' },
                { title: '操作', key: 'action', width: 140, align: 'center' },
            ],
            noticePage: {
                currentPage: 1,
                pageSize: 5,
                total: 0
            },
            noticeRelease: {
                isShow: false,
                data: {
                    pluginId: -1,
                    title: "",
                    content: ""
                }
            },
            includes_data: [],
            selectIncludesId: -1
        }
    },
    methods: {
        goApiUrl() {
            location.href = this.deveploerConf.apiUrl;
        },
        isNull(text) {
            return isNull(text);
        },
        currentChange(page, pageSize) {
            this.noticePage.currentPage = page;
            this.noticePage.pageSize = pageSize;
            this.getNoticeByIncludes();
        },
        getNoticeByIncludes() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/notice/list', {
                currentPage: this.noticePage.currentPage,
                pageSize: this.noticePage.pageSize,
                pluginId: this.selectIncludesId

            }, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.noticeList = res.data.data.list;
                        this.noticePage.total = res.data.data.total;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        saveNotice(row) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/notice/save', JSON.stringify(row), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        message.success(res.data.msg)
                        setTimeout(() => {
                            this.getNoticeByIncludes();
                        }, 1000)
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error("失败")
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error("错误：" + err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getIncludes() {
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getIncludes', { timeout: 5000, headers }).then(
                res => {
                    if (res.data.code == 200) {
                        this.includes_data = res.data.data
                    } else if (res.data.code == 401) {
                        message.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    } else {
                        message.error(res.data.msg)
                    }
                }, err => {
                    message.error(err)
                }
            )
        },
        deleteNotice(id) {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/notice/del?id=' + id, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        message.success(res.data.msg);
                        this.getNoticeByIncludes();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        addNotice() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/notice/add', JSON.stringify(this.noticeRelease.data), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        message.success(res.data.msg);
                        this.noticeRelease.isShow = false;
                        this.getNoticeByIncludes();
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        }
    },
    mounted() {
        this.getNoticeByIncludes()
        this.getIncludes()
    }
})
</script>
